export default __webpack_public_path__ + "static/media/shma-mission.5592ed55.png";